/**
 * Singapura — AR Verification of Data: 반복부(loop) & 체크박스 설정.
 *   normalize 와 문서 컴포넌트가 **같은 config** 를 써서 화면 입력키 ↔ 템플릿 item 키가 어긋나지 않게 한다.
 *   화면 입력키 = `${prefix}_${i}_${field.s}` (i=1..count), 템플릿 loop item 키 = `field.k`.
 */
export interface VField { s: string; k: string; label: string; wide?: boolean }
export interface VLoop { arrayKey: string; countKey: string; prefix: string; title: string; letter?: boolean; fields: VField[] }

const PERSON = (pfx: string): VField[] => [
  { s: 'name', k: `${pfx}_name`, label: 'Name', wide: true },
  { s: 'residential_address', k: `${pfx}_residential_address`, label: 'Residential address', wide: true },
  { s: 'contact_address', k: `${pfx}_contact_address`, label: 'Contact address', wide: true },
  { s: 'id_no', k: `${pfx}_id_no`, label: 'NRIC / Passport / FIN No.' },
  { s: 'nationality', k: `${pfx}_nationality`, label: 'Nationality' },
  { s: 'email', k: `${pfx}_email`, label: 'Email address' },
  { s: 'mobile', k: `${pfx}_mobile`, label: 'Mobile phone number' },
  { s: 'appointment_date', k: `${pfx}_appointment_date`, label: 'Date of appointment' },
];

export const V_LOOPS: VLoop[] = [
  { arrayKey: 'directors', countKey: 'director_count', prefix: 'director', title: 'Particulars of Directors', letter: true, fields: PERSON('director') },
  { arrayKey: 'managing_directors', countKey: 'md_count', prefix: 'md', title: 'Particulars of Managing Director', fields: PERSON('md') },
  { arrayKey: 'ceos', countKey: 'ceo_count', prefix: 'ceo', title: 'Particulars of Chief Executive Officer', fields: PERSON('ceo') },
  { arrayKey: 'secretaries', countKey: 'secretary_count', prefix: 'company_secretary', title: 'Particulars of Secretary', fields: PERSON('company_secretary') },
  {
    arrayKey: 'auditors', countKey: 'auditor_count', prefix: 'auditor', title: 'Particulars of Auditors',
    fields: [
      { s: 'firm_name', k: 'auditor_firm_name', label: 'Name of audit firm', wide: true },
      { s: 'address', k: 'auditor_address', label: 'Address', wide: true },
      { s: 'uen', k: 'auditor_uen', label: 'UEN' },
      { s: 'appointment_date', k: 'auditor_appointment_date', label: 'Date of appointment' },
    ],
  },
  {
    arrayKey: 'shareholders', countKey: 'shareholder_count', prefix: 'shareholder', title: 'Particulars of Shareholders and shareholdings', letter: true,
    fields: [
      ...PERSON('shareholder').slice(0, 7), // name..mobile (선임일 제외)
      { s: 'shares_held', k: 'shareholder_shares_held', label: 'No. of shares held' },
      { s: 'percent', k: 'shareholder_percent', label: 'Shareholding (%)' },
    ],
  },
];

export const V_SHARE_CAPITAL: VLoop = {
  arrayKey: 'share_capitals', countKey: 'share_capital_count', prefix: 'share_capital', title: 'Summary of share capital and shares',
  fields: [
    { s: 'currency', k: 'currency', label: 'Currency' },
    { s: 'issued_ordinary', k: 'issued_ordinary', label: 'Issued share capital (Ordinary)' },
    { s: 'issued_preference', k: 'issued_preference', label: 'Issued share capital (Preference)' },
    { s: 'paidup_ordinary', k: 'paidup_ordinary', label: 'Paid-up capital (Ordinary)' },
    { s: 'paidup_preference', k: 'paidup_preference', label: 'Paid-up capital (Preference)' },
    { s: 'shares_ordinary', k: 'shares_ordinary', label: 'Number of shares (Ordinary)' },
    { s: 'shares_preference', k: 'shares_preference', label: 'Number of shares (Preference)' },
  ],
};

export const V_CHARGES: VLoop = {
  arrayKey: 'charges', countKey: 'charge_count', prefix: 'charge', title: 'Charges registered with ACRA',
  fields: [
    { s: 'date', k: 'charge_date', label: 'Date of registration' },
    { s: 'no', k: 'charge_no', label: 'Charge No.' },
    { s: 'amount', k: 'charge_amount', label: 'Amount secured' },
    { s: 'chargee', k: 'chargee_name', label: 'Name of Chargee' },
  ],
};

export const V_YESNO: Array<{ k: string; label: string }> = [
  { k: 'revenue_exceeds_10m', label: 'Revenue exceeding SGD10 million?' },
  { k: 'total_assets_exceeds_10m', label: 'Total assets exceeding SGD10 million?' },
  { k: 'employees_over_50', label: 'More than 50 employees?' },
  { k: 'is_subsidiary', label: 'Is the company a subsidiary?' },
  { k: 'has_subsidiary_associate_jv', label: 'Has subsidiary / associate / joint venture?' },
];

export const V_EMP_BANDS: Array<{ v: string; label: string }> = [
  { v: 'lt50', label: 'less than 50' }, { v: '51_100', label: '51 to 100' }, { v: '101_150', label: '101 to 150' },
  { v: '151_200', label: '151 to 200' }, { v: 'gt200', label: 'More than 200' }, { v: 'na', label: 'Not applicable' },
];
